import React, { useState, memo } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import GetADemoDialog from '../GetADemoDialog';
import AvailableAppCard from '../AvailableAppCard';

import { selectApps } from '../../selectors/applications';
import { selectAccess } from '../../selectors/auth';

function CustomizedExpansionPanels({ access, apps }) {
  const [expanded, setExpanded] = useState('panel1');

  const [demoFormOpen, setDemoFormOpen] = useState(false);

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleDemoFormClick = () => {
    setDemoFormOpen(true);
  };

  const handleDemoFormClose = () => {
    setDemoFormOpen(false);
  };

  if (!apps) return <></>;

  const availableApps = apps.filter(app => {
    if (access.isInternal) return false;
    if (app.isSubscribed) return false;
    if (!app.isAvailable) return false;
    return true;
  });

  const view = (
    <>
      {availableApps
        .filter(({ meta: { slides } }) => slides.length)
        .map((app, idx) => (
          <AvailableAppCard
            key={app.id}
            expanded={expanded}
            panelId={`panel${idx}`}
            handleChange={handleChange}
            handleDemoFormClick={handleDemoFormClick}
            app={app}
          />
        ))}
      <GetADemoDialog open={demoFormOpen} onClose={handleDemoFormClose} />
    </>
  );

  return <div>{view}</div>;
}

CustomizedExpansionPanels.defaultProps = {
  access: {},
  apps: { apps: [] },
};

CustomizedExpansionPanels.propTypes = {
  access: PropTypes.shape({
    isAdmin: PropTypes.bool,
    isInternal: PropTypes.bool,
  }),
  apps: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string,
        description: PropTypes.string,
        auth: PropTypes.shape({
          default: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string])),
        }),
        meta: PropTypes.shape({
          logo: PropTypes.string,
          link: PropTypes.string,
          slides: PropTypes.arrayOf(
            PropTypes.oneOfType([
              PropTypes.shape({
                title: PropTypes.string,
                copy: PropTypes.string,
                img: PropTypes.string,
              }),
            ])
          ),
        }),
      }),
    ])
  ),
};

const mapStateToProps = createStructuredSelector({
  access: selectAccess(),
  apps: selectApps(),
});

export function mapDispatchToProps() {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(CustomizedExpansionPanels);
